import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPending = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 33,
	viewBox: "0 0 32 33",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_3192_8287)",
		children: [/* @__PURE__ */ _jsx("path", {
			d: "M3.60353 32.5355C2.57682 32.5355 1.71955 32.1916 1.03173 31.5037C0.34391 30.8159 0 29.9586 0 28.9319V7.13899C0 6.11228 0.34391 5.25501 1.03173 4.56719C1.71955 3.87937 2.57682 3.53546 3.60353 3.53546H8.3225V5.76623H3.60353C3.26036 5.76623 2.94577 5.90922 2.65975 6.19521C2.37376 6.48123 2.23077 6.79582 2.23077 7.13899V28.9319C2.23077 29.2751 2.37376 29.5897 2.65975 29.8757C2.94577 30.1617 3.26036 30.3047 3.60353 30.3047H27.6272C27.9704 30.3047 28.285 30.1617 28.571 29.8757C28.857 29.5897 29 29.2751 29 28.9319V7.13899C29 6.79582 28.857 6.48123 28.571 6.19521C28.285 5.90922 27.9704 5.76623 27.6272 5.76623H22.9083V3.53546H27.6272C28.654 3.53546 29.5112 3.87937 30.199 4.56719C30.8869 5.25501 31.2308 6.11228 31.2308 7.13899V28.9319C31.2308 29.9586 30.8869 30.8159 30.199 31.5037C29.5112 32.1916 28.654 32.5355 27.6272 32.5355H3.60353Z",
			fill: "currentColor"
		}), /* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M16 22.394C18.7614 22.394 21 20.1555 21 17.394C21 14.6326 18.7614 12.394 16 12.394C13.2386 12.394 11 14.6326 11 17.394C11 20.1555 13.2386 22.394 16 22.394ZM13 18.394C13.5523 18.394 14 17.9463 14 17.394C14 16.8418 13.5523 16.394 13 16.394C12.4477 16.394 12 16.8418 12 17.394C12 17.9463 12.4477 18.394 13 18.394ZM17 17.394C17 17.9463 16.5523 18.394 16 18.394C15.4477 18.394 15 17.9463 15 17.394C15 16.8418 15.4477 16.394 16 16.394C16.5523 16.394 17 16.8418 17 17.394ZM19 18.394C19.5523 18.394 20 17.9463 20 17.394C20 16.8418 19.5523 16.394 19 16.394C18.4477 16.394 18 16.8418 18 17.394C18 17.9463 18.4477 18.394 19 18.394Z",
			fill: "currentColor"
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_3192_8287",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "none",
			transform: "translate(0 0.894043)"
		})
	}) })]
});
export default SvgPending;
